import React from "react";
import Sprite from "./Sprite";
import { SNOW, SPARKLES } from "./atlas";

/**
 * Christmas hover for a listing photo: a row of snow caps slides down onto
 * its top edge, and a gold star starts to twinkle.
 *
 * Shared by the public ListingCard and the panel's ObjectCard, like
 * halloween/CardSpooks. The photo box must be position: relative with
 * overflow: hidden, and the card's sx must spread CARD_FROST_HOVER.
 */

/** Spread into the card's sx: a warm hover glow, and the hover that reveals the frost. */
export var CARD_FROST_HOVER = {
  "&:hover": {
    transform: "translateY(-3px)",
    boxShadow: "0 14px 34px rgba(224,165,38,0.24)",
    borderColor: "rgba(224,165,38,0.6)",
  },
  "&:hover .xm-card-cap": { transform: "translateY(0)" },
  "&:hover .xm-card-spark": { opacity: 1 },
};

var CAPS = ["cap0", "cap1", "cap0", "cap1", "cap0", "cap1", "cap0", "cap1"];

export default function CardFrost() {
  return (
    <React.Fragment>
      <span className="xm-card-cap" aria-hidden="true">
        {CAPS.map(function (name, index) {
          return <Sprite key={index} atlas={SNOW} name={name} />;
        })}
      </span>
      {/* The wrapper fades in on hover; the star inside keeps its own twinkle. */}
      <span className="xm-card-spark" aria-hidden="true" style={{ top: 38, right: 16 }}>
        <Sprite atlas={SPARKLES} name="gold0" scale={0.5} className="xm-twinkle" />
      </span>
    </React.Fragment>
  );
}
